import { format, isValid, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './prepaidCard.module.scss';

const Detail = ({ label, value, link }) => (
  <div className={styles.personalDetailBlock}>
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <span className={styles.personalDetailLabel}>{label}</span>
      {link}
    </div>
    {value.map((v, i) => (
      <div className={styles.personalDetail} key={i}>
        {v}
      </div>
    ))}
  </div>
);

const formatDateOfBirth = ({ year, month, date }) => {
  const dobString = `${year}-${month}-${date}`;

  return isValid(parseISO(dobString))
    ? format(parseISO(dobString), 'do MMM yyyy')
    : 'Invalid Date';
};

/** The details a recipient entered, as the confirmation step lists them. */
export const PrepaidFormDetails = ({ formData, emailAction }) => {
  const {
    firstName,
    lastName,
    phoneNumber,
    dateOfBirth,
    postalAddress,
    email,
  } = formData;
  const { addressLine1, addressLine2, city, postcode, country } = postalAddress;

  return (
    <div className={styles.heavyMargin}>
      <Detail label={'Full Name'} value={[`${firstName} ${lastName}`]} />
      <Detail label={'Phone number'} value={[phoneNumber]} />
      <Detail
        label={'Date of birth'}
        value={[formatDateOfBirth(dateOfBirth)]}
      />
      <Detail
        label={'Postal Address'}
        value={[addressLine1, addressLine2, city, postcode, country]}
      />
      <Detail label={'Email address'} value={[email]} link={emailAction} />
    </div>
  );
};

PrepaidFormDetails.propTypes = {
  formData: PropTypes.object.isRequired,
  emailAction: PropTypes.node,
};
